import type { Genero, Parentesco } from '../model/kartera-api-model'

export const PARENTESCOS: Array<{ id: Parentesco; label: string }> = [
    { id: 'titular', label: 'Titular' },
    { id: 'conyuge', label: 'Cónyuge' },
    { id: 'hijo', label: 'Hijo(a)' },
    { id: 'otro', label: 'Otro' },
]

export const GENEROS: Array<{ id: Genero; label: string }> = [
    { id: 'hombre', label: 'Hombre' },
    { id: 'mujer', label: 'Mujer' },
]
